import {
  DELETE_CUSTOMER_MESSAGE,
  REQUEST_CUSTOMER_MESSAGES,
  RECEIVE_CUSTOMER_MESSAGES,
  RECEIVE_CUSTOMER_MESSAGES_ERROR,
} from '../actions/customerMessages';

export const initialState = {
  isFetching: false,
  messages: [],
};

export default function customerMessages(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CUSTOMER_MESSAGES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_CUSTOMER_MESSAGES: {
      const notDuplicatedMessages = Array.isArray(action.messages) ?
        action.messages
          // compare with state to remove duplicated
          .filter(message => !state.messages.some(el => el.id === message.id))
        :
        [];
      return {
        ...state,
        isFetching: false,
        messages: [
          ...state.messages,
          ...notDuplicatedMessages,
        ],
      };
    }
    case RECEIVE_CUSTOMER_MESSAGES_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case DELETE_CUSTOMER_MESSAGE: {
      const messages = state.messages.filter(message => message.id !== action.message.id);
      return {
        ...state,
        isFetching: false,
        messages,
      };
    }
    default:
      return state;
  }
}
